<template>
  <div>
    <v-form ref="modelObjForm">
      <v-data-table :headers="headers" :items="membersList" :loading="loading" item-key="id" dense :footer-props="paginationList" class="bordered--table pa-2 mt-8">
      <template v-slot:body="{ items }">
        <tbody>
          <tr v-for="(item, index) in items" :key="item._id">
            <td>{{ item.name }}</td>
            <td>
              <v-text-field class="custom-padding ma-0" dense hide-details v-model="item.cost" @change="updateCost(item, index)" :rules="$_norwegianNumberValidation" @click="oldCostValue = item.cost"></v-text-field>
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
    </v-form>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  props: ['projectId'],
  data () {
    return {
      dialog: false,
      modelObj: {},
      membersList: [],
      paginationList: {
        'itemsPerPageOptions': [10, 25, 50, 100, -1]
      },
      total: 0,
      loading: false,
      MODULE: 'projectmembers',
      oldCostValue: 0
    }
  },
  created () {
    this.$store.dispatch('getUsers')
  },
  computed: {
    headers () {
      return [{
        text: this.$t('message.stamp.project'),
        value: 'name',
        isRoute: true,
        isModal: true,
        width: '35%'
      }, {
        text: this.$t('message.common.cost'),
        value: 'cost',
        width: '25%'
      }]
    },
    ...mapGetters(['getUsers'])
  },
  mounted () {
    this.getListHandler()
  },
  methods: {
    getListHandler () {
      this.loading = true
      this.$api.execute('get', `${this.MODULE}/get_by_project/${this.projectId}`)
        .then((response) => {
          let modelList = response.data.map(item => {
            let userObj = this.getUsers.find(x => x.id === item.person_id)
            let obj = null
            if (userObj) {
              obj = { id: item.id, name: userObj.name, cost: this.$format.replaceDotWithComma(item.cost) || 0 }
            }
            return obj
          })
          this.membersList = modelList
          this.loading = false
        })
    },
    updateCost (item, index) {
      if (this.$refs.modelObjForm.validate()) {
        item.cost = this.$format.replaceCommaWithDot(item.cost)
        let items = [item]
        this.$api.execute('post', `${this.MODULE}/update_cost`, items)
          .then((response) => {
            this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.savedSuccess') })
            this.getListHandler()
          })
      } else {
        this.membersList[index].cost = this.oldCostValue
        this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: `Enter only numbers` })
      }
    }
  }
}
</script>
<style>
.custom-padding input {
  padding: 0 !important;
}
.custom-padding {
  border-color: white !important;
}
</style>
